import i18n from '@/langs/i18n.js';

export default function () {
  return [
    {
      label: i18n.t('ui.settings'),
      name: 'settings',
      permissions: 'settings',
      to: '/ustawienia',
      type: 'router-link'
    },
    {
      label: i18n.t('articleForm.articles'),
      name: 'articles-list',
      permissions: 'articles',
      to: '/artykuly',
      type: 'router-link'
    },
    {
      label: i18n.t('ui.logout'),
      name: 'logout',
      theme: 'danger',
      to: '/wyloguj',
      type: 'router-link'
    }
  ];
}
